import type {QRDesignTile} from '@Components/qr-code-generator/qr-code-generator.types';

export interface QRSuggestedTemplatesProps {
  tiles: QRDesignTile[];
  blockClasses?: string;
  onTemplateSelect: (designHashedId: string) => Promise<void>;
  onBrowseAllClick: () => void;
}

export const QR_TEMPLATE_GALLERY_PATH = 'posters/gallery';
